import { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, IconButton, Box, CircularProgress, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { getRankingHistory } from '../../services/ranking.service';

const RankingHistoryModal = ({ open, handleClose, jugId, jugNombre }) => {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open && jugId) {
      setLoading(true);
      getRankingHistory(jugId)
        .then((data) => {
          // Process data for chart
          const formattedData = data.map((item) => ({
            fecha: new Date(item.ranking.rkg_fecha).toLocaleDateString(),
            puntaje: item.his_puntaje,
          })).reverse(); // Reverse to show chronological order
          setHistory(formattedData);
        })
        .catch((err) => console.error(err))
        .finally(() => setLoading(false));
    }
  }, [open, jugId]);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="md"
      PaperProps={{
        sx: {
          borderRadius: 0,
          background: '#0f172a',
          backgroundImage: 'none',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          color: '#cbd5e1',
        },
      }}
    >
      <DialogTitle sx={{ borderBottom: '1px solid rgba(255, 255, 255, 0.08)', pb: 1.5, fontWeight: 600 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          Historial de Ranking - {jugNombre}
          <IconButton onClick={handleClose} sx={{ color: '#94a3b8', '&:hover': { color: '#f8fafc' } }}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent sx={{ mt: 2 }}>
        {loading ? (
          <Box display="flex" justifyContent="center" p={4}>
            <CircularProgress />
          </Box>
        ) : history.length > 0 ? (
          <Box height={400} mt={2} bgcolor="#1e293b" p={2} border="1px solid rgba(255, 255, 255, 0.08)" borderRadius={0}>
            <ResponsiveContainer width="100%" height="100%">
              <LineChart data={history}>
                <CartesianGrid stroke="rgba(255, 255, 255, 0.08)" strokeDasharray="3 3" />
                <XAxis dataKey="fecha" tick={{ fontSize: 12, fill: '#94a3b8' }} stroke="rgba(255, 255, 255, 0.1)" />
                <YAxis domain={['auto', 'auto']} tick={{ fontSize: 12, fill: '#94a3b8' }} stroke="rgba(255, 255, 255, 0.1)" />
                <Tooltip contentStyle={{ backgroundColor: '#1e293b', borderColor: 'rgba(255, 255, 255, 0.15)', color: '#cbd5e1' }} />
                <Line type="monotone" dataKey="puntaje" stroke="#297dd6ff" strokeWidth={2.5} dot={{ r: 4, stroke: '#268cf9', strokeWidth: 2, fill: '#1e293b' }} activeDot={{ r: 6 }} />
              </LineChart>
            </ResponsiveContainer>
          </Box>
        ) : (
          <Box p={4} textAlign="center">
            <Typography sx={{ color: '#94a3b8' }}>No hay historial disponible.</Typography>
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default RankingHistoryModal;
